import Dropdown from "antd/es/dropdown";
import { Menu as MenuIcon } from "lucide-react";
import { Link } from "react-router-dom";
import { useAuth } from "../../contexts/SupabaseAuthContect";

export function NavbarDropdown() {
    const { role, logout } = useAuth();

    const items = [
        {
            key: "dashboard",
            label: (
                <Link to="/profile" className="block py-2 px-4">
                    Profiil
                </Link>
            ),
        },
        ...(role === "admin"
            ? [
                  {
                      key: "bookings",
                      label: (
                          <Link to="/stalls" className="block py-2 px-4">
                              Boksid
                          </Link>
                      ),
                  },
                  {
                      key: "cashier",
                      label: (
                          <Link to="/cashier" className="block py-2 px-4">
                              Maksed
                          </Link>
                      ),
                  },
              ]
            : []),
        {
            key: "logout",
            label: (
                <span onClick={logout} className="block py-2 px-4 text-red-500 cursor-pointer">
                    Logi välja
                </span>
            ),
        },
    ];

    return (
        <Dropdown
            menu={{ items, className: "w-56 text-lg" }} // use `menu` instead of `overlay`
            trigger={["click"]}
            placement="bottomRight"
        >
            <MenuIcon className="w-7 h-7 cursor-pointer text-muted-foreground hover:text-fuchsia-200" />
        </Dropdown>
    );
}
